import React, { useState } from "react";
import { Grid, Typography, Divider, Theme } from "@mui/material";
import { DatePicker } from "antd";
import { QuizConfig } from "../Helper/AssessmentHelper";
import { makeStyles } from "@mui/styles";
import KenSelect from "../../../../../../GlobalComponents/KenSelect";
import KenInput from "../../../../../../GlobalComponents/KenInput";
import { ITimeSetting } from "../index";
import { DROP_DOWN } from "../Helper/AssessmentHelper";
import dayjs from 'dayjs';
interface ITimeSettings {
    assessmentData: QuizConfig;
    setAssessmentData: React.Dispatch<React.SetStateAction<QuizConfig>>;
    timeSettings: ITimeSetting;
    setTimeSettings: React.Dispatch<React.SetStateAction<ITimeSetting>>;
    handleChange:(e: React.ChangeEvent<HTMLInputElement>) => void

}

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        fontWeight: 500,
        textAlign: "left",
    },
}));

const TimeSettings: React.FC<ITimeSettings> = ({
    assessmentData,
    setAssessmentData,
    timeSettings,
    setTimeSettings,
    handleChange
 }) => {
    const classes = useStyles();
    const [dateError, setDateError] = useState('');
    const [onTimeExpiration, setOnTimeExpiration] = useState("");

    const genMinuts = () => {
        return Array.from(Array(60).keys()).map(item => {
            let min = String(item);
            return {
                label: min.length == 1 ? '0' + item : String(item),
                value: min.length == 1 ? '0' + item : String(item),
            };
        });
    }
    const handleCloseTimeChange = (date: any) => {
        if (date && assessmentData.opentime && dayjs(date).isBefore(dayjs(assessmentData.opentime))) {
          setDateError('End time cannot be before start time');
        } else {
          setDateError('');
          setAssessmentData(prev => ({ ...prev, closetime: date }));
        }
      };

    return (
        <div>
            {/* Quiz Start & End Time */}
            <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography className={classes.label}>
          Quiz Start Time & Date <span style={{ color: 'red' }}>*</span>
        </Typography>
        <DatePicker
          showTime
          format="YYYY-MM-DD h:mm A"
          style={{ width: '100%', height: '3rem' }}
          value={assessmentData.opentime}
          onChange={(date) => {
            setAssessmentData({ ...assessmentData, opentime: date });
            // Reset end time if it's before the new start time
            if (assessmentData.closetime && dayjs(date).isAfter(dayjs(assessmentData.closetime))) {
              setAssessmentData(prev => ({ ...prev, closetime: null }));
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography className={classes.label}>
          Quiz End Time & Date <span style={{ color: 'red' }}>*</span>
        </Typography>
        <DatePicker
          showTime
          format="YYYY-MM-DD h:mm A"
          style={{ width: '100%', height: '3rem' }}
          value={assessmentData.closetime}
          onChange={handleCloseTimeChange}
        />
        {dateError && (
          <Typography style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>
            {dateError}
          </Typography>
        )}
      </Grid>
    </Grid>

            {/* Hours & Minutes in a Single Row */}
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12} md={3}>
                    <Typography className={classes.label}>Hours
                    <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <KenInput
                        type="number"
                        value={timeSettings.hours}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setTimeSettings({
                                ...timeSettings,
                                hours: e.target.value
                            })
                        }} />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography className={classes.label}>Minutes
                    <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <KenSelect
                        fullWidth
                        value={timeSettings.minutes}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setTimeSettings({
                                ...timeSettings,
                                minutes: e.target.value
                            })
                        }}
                        options={genMinuts()}
                        sx={{ height: "3rem" }}
                    />
                </Grid>
            </Grid>

            {/* On Time Expiration - 3 Items in a Row */}
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12} md={5}>
                    <Typography className={classes.label}>On time expiration</Typography>
                    <KenSelect
                        fullWidth
                        value={assessmentData.overduehandling}
                        name="overduehandling"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
                        options={DROP_DOWN.OnTimeExpirations}
                        sx={{ height: "3rem" }}
                    />
                </Grid>
                {assessmentData.overduehandling === "graceperiod" && (
                    <>
                        <Grid item xs={12} md={3}>
                            <Typography className={classes.label}>Submission Grace Period</Typography>
                            <KenInput value={assessmentData.graceperiod} name="graceperiod" onChange={handleChange}/>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ marginTop: "1.35rem" }}>
                            <KenSelect
                                fullWidth
                                defaultValue="Seconds"
                                options={["Weeks", "Days", "Hours", "Minutes", "Seconds"].map((unit) => ({ value: unit, label: unit }))}
                                sx={{ height: "3rem" }}
                            />
                        </Grid>
                    </>
                )}
            </Grid>

            <Divider sx={{ marginTop: 2 }} />
        </div>
    );
};

export default TimeSettings;
